export const SAVED_QUERY_QUERY_PARAM = 'accessScopeId';
export const SAVED_QUERY_LABEL = 'Saved Access Scope';
export const QUERY_QUERY_PARAM = 'query';
